import { QueryFormData } from '@superset-ui/core';
import { SupersetClient } from '@superset-ui/core';
import datasetsStore from './DatasetsStore';

const extractRlsFilters = (formData: QueryFormData) => {
  const rlsNativeFiltersMap = new Map();
  const rls_native_filters = SupersetClient.getRLSFilter();

  if (rls_native_filters) {
    let filters = rls_native_filters;
    filters = Array.isArray(filters) ? filters : [];

    filters.forEach((f: any) => {
      const { rls_col_alias, op, val } = f;

      if (rls_col_alias) {
        rlsNativeFiltersMap.set(rls_col_alias, { op, val });
      }
    });
  }

  if (rlsNativeFiltersMap.size === 0) return [];

  const [datasetId, chartType] = formData.datasource.split('__');
  if (!chartType) return [];

  const datasets = datasetsStore.resolve('datasets');

  if (!datasets || datasets.length === 0) return [];

  const dataset = datasets.find((i: any) => +i.id === +datasetId);

  if (!dataset) return [];

  const { columns } = dataset;

  const datasetFiltersMap = new Map();

  columns.forEach(c => {
    if (c?.description && c.description.startsWith('RLS')) {
      const rls_col_alias = c.description.split('_')?.[1];
      datasetFiltersMap.set(rls_col_alias, c.column_name);
    }
  });

  const filters = [];

  rlsNativeFiltersMap.forEach((val, key) => {
    const mappedColName = datasetFiltersMap.get(key);
    if (mappedColName) {
      filters.push({
        col: mappedColName,
        op: val.op,
        val: val.val,
      });
    }
  });

  return filters;
};

export default extractRlsFilters;
